import API from "../../../api/axiosClient";

 
const baseUrl = "GroupJoinRequest";

export const createJoinRequest = async (groupId: string) => {
    await API.post(baseUrl, {
        groupId
    });
};

export const getGroupRequests = async (groupId: string) => {
    const response = await API.get(
        `${baseUrl}/group/${groupId}`
    );

    return response.data;
};

export const getMyRequests = async () => {
    const response = await API.get(
        `${baseUrl}/myrequests`
    );

    return response.data;
};

export const approveRequest = async (requestId: string) => {
    await API.put(
        `${baseUrl}/${requestId}/approve`
    );
};

export const rejectRequest = async (
    requestId: string,
    remarks: string
) => {
    await API.put(
        `${baseUrl}/${requestId}/reject`,
        {
            remarks
        }
    );
};

export const getMyJoinRequestStatus = async (
    groupId: string
) => {
    const response = await API.get(
        `${baseUrl}/group/${groupId}/status`
    );

    return response.data;
};

export const cancelJoinRequest = async (
    groupId: string
) => {
    await API.delete(
        `${baseUrl}/group/${groupId}`
    );
};

